import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import update from 'immutability-helper';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import ArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';

const styles = theme => ({
  listItem: {
    height: 44,
    '&:hover': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
  },
  title: {
    paddingLeft: 16,
  },
  nested: {
    ...theme.typography.overline,
    paddingTop: 0,
    paddingBottom: 0,
  },
});

class ListToggle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openSections: {},
    };
  }

  toggleTopic = title => {
    const isOpen = !!this.state.openSections[title];
    const newState = update(this.state, {
      openSections: { [title]: { $set: !isOpen } },
    });
    this.setState(newState);
  };

  render() {
    const { data, classes, changeFilter } = this.props;
    const { openSections } = this.state;
    return (
      <section id="faq">
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" color="primary" className={classes.title}>
              All Topics
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List component="nav">
              {data.map(({ title, topicsCollection }) => (
                <React.Fragment key={title}>
                  <ListItem
                    button
                    onClick={() => this.toggleTopic(title)}
                    className={classes.listItem}
                  >
                    <Grid container direction="row">
                      <Grid item xs={11} className={classes.questionWrapper}>
                        <Typography variant="subtitle1">{title}</Typography>
                      </Grid>
                      <Grid item xs={1} className={classes.iconWrapper}>
                        {openSections[title] ? (
                          <ArrowUp className={classes.icon} alt="Arrow up" />
                        ) : (
                          <ArrowDown
                            className={classes.icon}
                            alt="Arrow down"
                          />
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Collapse
                    in={!!openSections[title]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {topicsCollection.items.map(
                        // eslint-disable-next-line no-shadow
                        ({ title, slug, sys: { id }, reviewStatus }) => {
                          if (reviewStatus !== 'Accepted') return null;
                          const event = {
                            target: {
                              value: title,
                            },
                          };
                          return (
                            <ListItem
                              button
                              className={classes.nested}
                              onClick={() =>
                                changeFilter(slug, event, 'selectedTopic', id)
                              }
                              key={slug}
                            >
                              <ListItemText primary={title} />
                            </ListItem>
                          );
                        },
                      )}
                    </List>
                  </Collapse>
                </React.Fragment>
              ))}
            </List>
          </Grid>
        </Grid>
      </section>
    );
  }
}

ListToggle.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  changeFilter: PropTypes.func,
};

export default withStyles(styles)(ListToggle);
